import { Badge, Group, Text } from "@mantine/core";
import {
  IconFolder,
  IconMail,
  IconMailOpened,
  IconSpeakerphone,
  IconSettings,
} from "@tabler/icons-react";
import { DataTable } from "../DataTable";
import {
  TableActions,
  TableAction,
  DeleteAction,
  actionsColumn,
} from "../TableActions";

export default function DocumentFileNamesTable({
  data,
  isPending,
  onSelect,
  onCreateAnnouncement,
  onOpenAnnouncement,
  onSendEmails,
  onOpenEmails,
  onDelete,
  isCreatingAnnouncement,
  isSendingEmails,
}) {
  const columns = [
    {
      accessor: "fileName",
      title: "Document Name",
      render: (row) => (
        <Group gap="sm">
          <IconFolder size={16} color="blue" />
          <Text size="sm" fw={500}>
            {row.fileName}
          </Text>
        </Group>
      ),
    },
    {
      accessor: "tag",
      title: "Distributed to",
      render: (row) => (
        <Badge variant="light" color={row.tagColor || undefined}>
          {row.tagId ? row.tagTitle : "All recipients"}
        </Badge>
      ),
    },
    {
      accessor: "count",
      title: "Documents",
      render: (row) => <Text size="sm">{row.count}</Text>,
    },
    actionsColumn((row) => (
      <TableActions>
        {row.announcementId ? (
          <TableAction
            label="Announcement settings"
            icon={IconSettings}
            color="blue"
            onClick={(event) => {
              // Prevent the row click that navigates into the distribution
              event.stopPropagation();
              onOpenAnnouncement(row.announcementId);
            }}
          />
        ) : (
          <TableAction
            label="Create announcement"
            icon={IconSpeakerphone}
            color="green"
            loading={isCreatingAnnouncement}
            onClick={(event) => {
              event.stopPropagation();
              onCreateAnnouncement(row.id);
            }}
          />
        )}
        {row.emailedCount > 0 && (
          <TableAction
            label="Email information"
            icon={IconMailOpened}
            color="blue"
            onClick={(event) => {
              event.stopPropagation();
              onOpenEmails(row.id);
            }}
          />
        )}
        {row.count > 0 && row.emailedCount === 0 && (
          <TableAction
            label="Send emails"
            icon={IconMail}
            color="blue"
            loading={isSendingEmails}
            onClick={(event) => {
              event.stopPropagation();
              onSendEmails(row);
            }}
          />
        )}
        <DeleteAction
          label="Delete distribution"
          onDelete={(event) => {
            event.stopPropagation();
            onDelete(row);
          }}
        />
      </TableActions>
    )),
  ];

  return (
    <DataTable
      columns={columns}
      records={data}
      fetching={isPending}
      onRowClick={({ record }) => onSelect(record.id)}
    />
  );
}
